export default "__VITE_ASSET__CbQtiwE1__"